const data = {
  backgroundColor: "#1e1f23",
  foregroundColor: "#1e1f23",
};

export default data;
